const translation = {
  it: {
    home: {
      name: "home",
      link: "/"
    },
    about: {
      name: "about",
      link: "/chi-siamo"
    },
    cellar: {
      name: "cellar",
      link: "/cantina"
    },
    cellars: {
      name: "cellars",
      link: "/cantine"
    },
    help: {
      name: "help",
      link: "/aiuto"
    },
    contacts: {
      name: "contacts",
      link: "/contatti"
    },
    terms: {
      name: "terms",
      link: "/termini-condizioni"
    },
    privacy: {
      name: "privacy",
      link: "/privacy"
    },
    experiences: {
      name: "experiences",
      link: "/esperienze"
    },
    experience: {
      name: "experience",
      link: "/esperienza"
    },
    bookingSummary: {
      name: "booking-summary",
      link: "/riepilogo-prenotazione"
    },
    paymentOk: {
      name: "paymentOk",
      link: "/pagamento-ok"
    },
    profile: {
      name: "profile",
      link: "/profilo"
    },
    product: {
      name: "product",
      link: "/prodotto"
    }
  },
  en: {
    home: {
      name: "home",
      link: "/en/home"
    },
    about: {
      name: "about",
      link: "/en/about"
    },
    cellar: {
      name: "cellar",
      link: "/en/cellar"
    },
    cellars: {
      name: "cellars",
      link: "/en/cellars"
    },
    help: {
      name: "help",
      link: "/en/help"
    },
    contacts: {
      name: "contacts",
      link: "/en/contacts"
    },
    terms: {
      name: "terms",
      link: "/en/terms"
    },
    privacy: {
      name: "privacy",
      link: "/en/privacy"
    },
    experiences: {
      name: "experiences",
      link: "/en/experiences"
    },
    experience: {
      name: "experience",
      link: "/en/experience"
    },
    bookingSummary: {
      name: "booking-summary",
      link: "/en/booking-summary"
    },
    paymentOk: {
      name: "paymentOk",
      link: "/en/payment-ok"
    },
    profile: {
      name: "profile",
      link: "/en/profile"
    },
    product: {
      name: "product",
      link: "/en/product"
    }
  }
};
export default translation;
